import client from '../client'

export const gameApi = {
  partnerList: async () => {
    const data = await client.get('User')
    return data
  },
  gameCode: async (body: any) => {
    const data = await client.post('Team/LoginTeam', null, {
      params: {
        gameCode: body,
      },
    })
    return data
  },
  getConsent: async ({
    gameId,
    localeId,
  }: {
    gameId: number
    localeId: number
  }) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''

    const data = await client.get(`Team/ConsentHtml/${gameId}/${localeId}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getInstructions: async ({
    gameId,
    localeId,
  }: {
    gameId: number
    localeId: number
  }) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''

    const data = await client.get(
      `Team/InstructionsHtml/${gameId}/${localeId}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`,
        },
      },
    )
    return data
  },
  checkIfTimerIsSet: async () => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''

    const data = await client.get('Team/EndTimer', {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  freeGameLogin: async (body: any) => {
    const data = await client.post('Team/LoginTeamFreeGame', null, {
      params: {
        freeGameId: body,
      },
    })
    return data
  },
  addTeamName: async (body: any) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    // console.log('token', token)
    const data = await client.post('Team/AddTeamName', null, {
      params: {
        teamName: body,
      },
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  updateTeamName: async (body: any) => {
    const data = await client.put('Team/UpdateTeamName', body)
    return data
  },
  checkIfTeamNameIsAdded: async () => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/CheckIfTeamNameIsAdded', {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  bookGame: async (body: any) => {
    const data = await client.post('/BookedGame', body)
    return data
  },
  bookedGamesByUsers: async () => {
    const data = await client.get('BookedGame/BookedGamesByUsers')
    return data
  },
  bookedGamesByCities: async () => {
    const data = await client.get('BookedGame/BookedGamesByCities')
    return data
  },
  bookedGamesTotalsInRange: async () => {
    const data = await client.get('BookedGame/BookedGamesTotalsInRange')
    return data
  },
  bookedGamesTotals: async () => {
    const data = await client.get('BookedGame/BookedGamesTotals')
    return data
  },
  getLeaderboard: async (params: any) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/Leaderboard', {
      params,
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getTeamOnLeaderboard: async () => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/TeamOnLeaderboard', {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getGameCode: async () => {
    // const data = await client.get('Team/GetGameCode')
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetGameCode', {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  legalUrls: async () => {
    // const data = await client.get('Team/GetGameCode')
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetGameLegalUrls', {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getWelcomeScreen: async (localeId: number) => {
    // const data = await client.get('Team/GetGameCode')
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetWelcomeScreen', {
      params: {
        localeId,
      },
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getEndScreen: async (localeId: number) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetEndScreen', {
      params: {
        localeId,
      },
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getGameLocales: async () => {
    // const data = await client.get('Team/GetGameCode')
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetGameLocales', {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getMapStyle: async () => {
    // const data = await client.get('Team/GetGameCode')
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetGameMapStyle', {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getLocationsOnMap: async () => {
    // const data = await client.get('Team/GetGameCode')
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetLocationsOnMap', {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getGamesByUser: async (id: number) => {
    const data = await client.get(`Game/GamesByUser/${id}`)
    return data
  },
  postPuzzleAnswer: async (body: any) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    // console.log('token', body)
    const data = await client.post('Team/CheckAnswer', body, {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getIsQuestionSolved: async ({ questionId, localeId, reason }: any) => {
    // const data = await client.get('Team/GetGameCode')
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetIsPuzzleSolved', {
      params: { questionId, localeId, reason },
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getQuestionByLocale: async ({ questionId, localeId }: any) => {
    // const data = await client.get('Team/GetGameCode')
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetPuzzleQuestionByLocale', {
      params: { questionId, localeId },
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getQuestionWellDoneByLocale: async ({ questionId, localeId }: any) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetPuzzleQuestionWellDoneByLocale', {
      params: { questionId, localeId },
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getQuestionSkipByLocale: async ({ questionId, localeId }: any) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetPuzzleQuestionSkipByLocale', {
      params: { questionId, localeId },
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  postPuzzleHint: async (body: any) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    // console.log('token', token)
    const data = await client.post('Team/UsePuzzleHint', body, {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getUsedHints: async ({ questionId, localeId }: any) => {
    // const data = await client.get('Team/GetGameCode')
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get('Team/GetUsedHints', {
      params: { questionId, localeId },
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  postSkipPuzzle: async (params: any) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    // console.log('token', token)
    const data = await client.post('Team/SkipPuzzle', null, {
      params: {
        questionId: params.questionId,
        localeId: params.localeId,
        puzzleSolvedTime: params.puzzleSolvedTime,
      },
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getCollectedItems: async (localeId: any) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get(
      `Team/GetCollectedItems?localeId=${localeId}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`,
        },
      },
    )
    return data
  },
  getInitialData: async (url: any) => {
    const data = await client.get(
      `User/GetUserDataByDomain?url=${
        url.endsWith('/') ? url.slice(0, -1) : url
      }`,
    )
    return data
  },
  getFinalPuzzle: async (localeId: any) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get(`Team/GetFinalPuzzle?localeId=${localeId}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getTeamName: async () => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get(`Team/GetTeamName`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getProgress: async () => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get(`Team/GetProgress`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  postLogout: async () => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    // console.log('token', token)
    const data = await client.post('Team/LogoutPlayer', null, {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
  getPuzzleWellDoneBackground: async ({
    questionId,
  }: {
    questionId: number
  }) => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    const data = await client.get(`Team/GetPuzzleWellDoneImage/${questionId}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
    })
    return data
  },
}
